/**
 * Blended-average cost basis for LMSR sells (mirror of `sell_lmsr_shares` pre-loop math).
 */

export interface LmsrBetBasisRow {
  shares_owned: number;
  amount: number;
  amount_after_fee?: number | null;
  created_at?: string;
}

export function blendedBasisSold(rows: LmsrBetBasisRow[] | null | undefined, sellShares: number): number {
  if (!rows || rows.length === 0 || sellShares <= 0) return 0;

  let totalCost = 0;
  let totalShares = 0;

  for (const row of rows) {
    if (row.shares_owned > 0) {
      const rowCost = row.amount_after_fee ?? row.amount;
      totalCost += rowCost;
      totalShares += row.shares_owned;
    }
  }

  if (totalShares === 0) return 0;

  const avgPrice = totalCost / totalShares;
  return Number((sellShares * avgPrice).toFixed(2));
}
